module.exports = __webpack_public_path__ + "static/img/jiadian-banner.d08851a0.png";